export const integrationWords = {
  title: "Integrations",
  description: "Manage institutional connections and instructor access.",
  settings: "Institution settings",
  google: "Google Workspace",
  zoom: "Zoom",
  diagnostics:
    "Configuration is read from this deployment. Provider access has not been checked by this read.",
  failed: "Integration details are unavailable. Try again.",
  notConfigured: "Setup needed",
  configured: "Configured",
  disabled: "Disabled in this deployment",
  unsupported: "Not available for this institution",
  manual: "Manual meeting links and material URLs remain available.",
  providerSetup:
    "The institution's integration operator manages credentials, provider permissions, and release enablement.",
  noValue: "Not configured",
  conflict:
    "Zoom access changed. Reload the current details, then review your action.",
  reload: "Load current details",
  refresh: "Refresh diagnostics",
  action: "Action",
  host: "IMAM host",
  zoomId: "Immutable Zoom user ID",
  idHelp:
    "Copy the exact user ID from the institutional Zoom account. Email addresses and names cannot identify a host.",
  reason: "Reason for revoking access",
  apply: "Apply Zoom action",
  manage: "Manage Zoom access",
  account: "Institutional Zoom account",
  hosts: "Instructor hosts",
  noHosts: "No eligible IMAM hosts or existing bindings.",
  accountNeeded:
    "Verify the institutional account before managing hosts or enabling creation.",
  noBinding: "Not bound",
  revoked: "Revoked",
  licensed: "Licensed",
  unlicensed: "Unlicensed",
  unknownLicense: "License not verified",
  enabled: "Managed creation enabled",
  stopped: "Managed creation disabled",
  accountAbsent: "No account verified",
  verifiedAccount:
    "Account configured from exact Zoom readback. Verify the account before enabling managed creation.",
  unchangedMeetings:
    "Existing meetings, recordings, and manual links are preserved. This action changes IMAM's connection records.",
  saved: "Zoom access updated.",
  chooseHost: "Choose an IMAM host.",
  enterId:
    "Enter one immutable Zoom user ID without spaces or an email address.",
  enterReason: "Give a reason for revoking access.",
  releaseBlocked:
    "Managed creation is disabled by release configuration. Contact the integration operator.",
  manageOpen: "Choose an action",
  reviewAction: "Review this account or host action before applying it.",
  accountId: "Account ID",
  providerId: "Zoom user ID",
  verifiedAt: "Last verified",
  accountActive: "Account active",
  no: "No",
  yes: "Yes",
  picker: "Drive file chooser",
  pickerReady: "Available in this browser build",
  pickerOff: "Disabled or incomplete in this browser build",
  pickerHelp:
    "The chooser uses a separate browser-only grant. File access and sharing remain controlled by Google.",
  signin: "Google sign-in",
  signinHelp:
    "This checks the registered IMAM sign-in issuer configuration. It does not verify Google's OAuth client or grant LMS membership.",
  directory: "Workspace accounts",
  directoryHelp:
    "Account setup and lifecycle actions remain in People. Directory access does not grant an IMAM role.",
  drive: "Institutional Drive folders",
  driveHelp:
    "The operator and root apply to IMAM-created folders. Existing folder references and Google's sharing rules are preserved.",
  classroom: "Classroom intake and references",
  classroomHelp:
    "New coursework stays in IMAM. The connection shown belongs to you and is used for registrar intake.",
  intake: "Open Classroom intake",
  noConnection: "No current intake connection",
  meet: "Google Meet",
  meetHelp:
    "Managed creation is an instructor action for one session. Calendar synchronization and recording discovery are separate capabilities.",
  configuredLabel: "Deployment configuration",
  managedCreation: "Managed creation allowed by deployment",
  institutionDomain: "Institution domain",
  issuer: "Registered sign-in issuer",
  provisioning: "Account provisioning",
  orgUnit: "Managed account area",
  operator: "Drive operator",
  root: "Shared drive root",
  domainMatch: "Operator matches institution domain",
  intakeEnabled: "Registrar intake",
  references: "Read-only references",
  connectionState: "Your intake grant",
  subject: "Connected Google subject",
  scopes: "Required permissions complete",
  currentClient: "Connection matches current app configuration",
  inactive: "IMAM access inactive",
  roleEnded: "IMAM host role ended",
  activeGrant: "Active grant recorded",
  reconnect: "Reconnect required",
  permissions:
    "Connection permissions and reconnect are managed in Classroom intake.",
  recordings: "Recording discovery",
  recordingConfig: "Recording credentials",
  recordingHelp:
    "Meeting creation and recordings use separate credentials. Discovery does not publish a recording.",
  recordingSettings: "Recording receiver and sign-in settings",
  zoomHelp:
    "Hosts use exact verified IMAM and Zoom identities. An enabled release still needs a verified account and eligible host.",
} as const;
export const zoomActionWords = {
  verify_account: "Verify institutional account",
  verify_host: "Bind or verify instructor host",
  enable: "Enable managed creation",
  disable: "Disable managed creation",
  revoke_account: "Revoke institutional connection",
  revoke_host: "Revoke instructor host",
} as const;
